import { useRouter } from 'next/router';
import * as React from 'react';

import { isThirdElem } from '../../shared/utils';
import { Lesson } from '../cards/lesson.component';
import { Collapse, CollapseHeader } from '../collapse';
import { MoreActionMenu } from '../menu';
import { Pagination } from '../pagination/pagination.component';
import {
  BodyWrap,
  EmptyState,
  FootWrap,
  Loaders,
  ShowMoreBtn,
  SortActiveText,
} from './sub-components';
import { LessonsListProps } from './types';

const { Fragment, useCallback } = React;

export const LessonsList = ({
  sortTxt,
  activeSortValue,
  sortMenuOptions,
  onClickSortValue,
  showTxt,
  title,
  lessons,
  paginationProps,
  onClickShowToggle,
  isShowMore,
  emptyPlaceholders,
  translations,
  isLoading,
  handlePinLesson,
}: LessonsListProps): JSX.Element => {
  const router = useRouter();
  const orgId = router?.query?.orgId;
  const mode = router?.query?.mode;
  const [isCollapsed, setIsCollapsed] = React.useState(false);
  const [isSortMenuOpened, setIsSortMenuOpened] = React.useState(false);

  const handleCollapseToggle = () => {
    setIsCollapsed(!isCollapsed);
  };
  const handleSortOpen = () => {
    setIsSortMenuOpened(true);
  };
  const handleSortClose = () => {
    setIsSortMenuOpened(false);
  };

  const CollapseActionButton = useCallback(
    () => (
      <MoreActionMenu
        menuItems={sortMenuOptions}
        icon={
          <SortActiveText
            isSortMenuOpened={isSortMenuOpened}
            sortTxt={sortTxt}
            activeSortValue={activeSortValue}
          />
        }
        onClickMenuItem={onClickSortValue}
        onOpenMenu={handleSortOpen}
        onCloseMenu={handleSortClose}
      />
    ),
    [isSortMenuOpened]
  );
  return (
    <div>
      <CollapseHeader
        titleClassName="font-medium"
        title={title}
        wrapperClassNames="pb-10 border-b mb-16 font-medium text-base text-gray-999"
        isOpen={!isCollapsed}
        onToggle={handleCollapseToggle}
        iconRight={CollapseActionButton()}
      />
      <div className="mb-64">
        <Collapse isOpened={!isCollapsed}>
          {isLoading ? <Loaders /> : null}
          <BodyWrap>
            {lessons.length > 0 ? (
              <Fragment>
                {lessons.map((lesson: any, index) => (
                  <Lesson
                    className={`mb-16 ${isThirdElem(index + 1) ? '' : 'mr-16'}`}
                    slug={lesson.slug}
                    handlePinLesson={handlePinLesson}
                    pinned={lesson.pin}
                    key={`${lesson?.title}${index}`}
                    translations={translations}
                    href={`/${mode}/${orgId}/lessons/${lesson.slug}`}
                    imageUrl={lesson?.image?.url}
                    imageAlt={lesson?.image?.alt}
                    {...lesson}
                  />
                ))}
              </Fragment>
            ) : !isLoading ? (
              <EmptyState
                src={emptyPlaceholders.image.url}
                contents={emptyPlaceholders.contents}
                showVideo={emptyPlaceholders.showVideo}
                thumbnailUrl={
                  'https://res.cloudinary.com/samvibes/image/upload/walkthrough-thumbnails/lesson-walkthrough.png'
                }
                videoId={'DRlE-XaUTuE'}
              />
            ) : null}
          </BodyWrap>
          <FootWrap>
            {isShowMore ? <ShowMoreBtn onClick={onClickShowToggle}>{showTxt}</ShowMoreBtn> : null}
            {!isShowMore && (paginationProps.total || 0) > 6 ? (
              <Pagination {...paginationProps} />
            ) : null}
          </FootWrap>
        </Collapse>
      </div>
    </div>
  );
};
